import {Box, Table, TableBody, TableRow, TableCell, TableHead, IconButton, Tooltip, Paper} from "@mui/material";
import useApiCall from "../hooks/CancellableApiCall";
import {SuspensionsResponse} from "../data/SuspensionsResponse";
import {PoliceUser} from "../components/PoliceUser";
import {Policy} from "@mui/icons-material";
import {useNavigate} from "react-router-dom";
import {formatTimestamp} from "../utils";
import {makeApiCall} from "../hooks/CancellableApiCall";

export const ActiveSuspensionsPage = () => {
    const loadSuspensions = useApiCall<SuspensionsResponse[]>({
        url: `/api/records/suspensions`
    })

    const navigate = useNavigate()


return (
    <Paper variant={"outlined"} style={{
        padding: "16px",
        overflowX: "auto"
            }}>
            <Box sx={{overflowX:"auto"}}>
            <Table>
                <TableHead>
                    <TableRow>
                       <TableCell>Supervisor</TableCell>
                       <TableCell>Employee</TableCell>
                       <TableCell>Reason</TableCell>
                       <TableCell>Suspension Date</TableCell>
                       <TableCell>Actions</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {loadSuspensions.data && loadSuspensions.data.map((s) => {
                        return <TableRow key={s.communityId}>
                            <TableCell><PoliceUser user={{nick: s.supervisorNick, communityId: s.supervisorCommunityId}}/></TableCell>
                            <TableCell><PoliceUser user={{nick: s.nick, communityId: s.communityId}}/></TableCell>
                            <TableCell>{s.reason}</TableCell>
                            <TableCell>{formatTimestamp(s.date)}</TableCell>
                            <TableCell>
                            <Tooltip title={"Visit Infractions Page"}>
                            <IconButton size="small" color="error" onClick={() =>
                                makeApiCall({
                                    url: `/api/records/search/${s.communityId}`,
                                    method: "POST",
                                    body: {
                                        reason: "Suspension Query",
                                        target: s.communityId
                                    },
                                    onLoadedCallback: (data: {sessionId: string}) => {
                                        navigate(`/records/${s.communityId}/infractions?session=${data.sessionId}`)
                                    },
                                    onError: () => {
                                    }
                                })
                            }>
                            <Policy color={"error"} />
                            </IconButton>
                        </Tooltip>
                                    </TableCell>
                        </TableRow>
                    })
                    }
                </TableBody>
            </Table>
            </Box>
            </Paper>
        )}